import { useEffect, useState } from "react";
import { Activity } from "lucide-react";
import { supabase } from "@/integrations/supabase/client";
import { useTranslation } from "@/i18n";

const LiveCounter = () => {
  const { t } = useTranslation();
  const [count, setCount] = useState<number | null>(null);

  useEffect(() => {
    const fetchCount = async () => {
      try {
        const since = new Date(Date.now() - 24 * 60 * 60 * 1000).toISOString();
        const { count: total } = await supabase
          .from("seo_generations")
          .select("*", { count: "exact", head: true })
          .gte("created_at", since);
        setCount(total ?? 0);
      } catch {
        setCount(0);
      }
    };
    fetchCount();
  }, []);

  const displayCount = count !== null && count > 10 ? count : null;

  return (
    <section className="py-4">
      <div className="container mx-auto px-4">
        <div className="flex items-center justify-center gap-3 py-3 px-6 rounded-full glass-card max-w-xl mx-auto">
          {/* Pulsing green dot */}
          <span className="relative flex h-3 w-3">
            <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-[hsl(142,71%,45%)] opacity-75" />
            <span className="relative inline-flex rounded-full h-3 w-3 bg-[hsl(142,71%,45%)]" />
          </span>

          <p className="text-sm text-muted-foreground">
            {displayCount ? (
              <>
                <span className="font-semibold text-foreground">
                  {displayCount.toLocaleString()}
                </span>{" "}
                {t('liveCounter.productsOptimized24h')}
              </>
            ) : (
              t('liveCounter.fallback')
            )}
          </p>

          <Activity size={16} className="text-primary" />
        </div>
      </div>
    </section>
  );
};

export default LiveCounter;
